'use client';

import { css } from 'styled-components';

export type Radius = { sm: string; md: string; full: string };

export const radiusTokens: Radius = {
  sm: '--radius-sm',
  md: '--radius-md',
  full: '--radius-full',
};

export const generateRadiusTokens = (values: Record<keyof typeof radiusTokens, string>) => {
  return css`
    ${radiusTokens.sm}: ${values.sm};
    ${radiusTokens.md}: ${values.md};
    ${radiusTokens.full}: ${values.full};
  `;
};
